export default {
  main: '#E0BC99',
  secondary: '#000000',
  contrastingColor: '#ffffff',
  priceColor: '#E0BC99',
  entryBackground: '#E0BC99',
  menuBackgroundColor: '#ffffff',
  menuTextColor: '#000000',
};
